import { createPromiseAction } from '@adobe/redux-saga-promise';

import { RECHARGE_FASTAG, SET_MIN_BALANCE, AUTO_RECHARGE } from './constants';

export const rechargeFastag = createPromiseAction(RECHARGE_FASTAG);

export const setMinBalance = createPromiseAction(SET_MIN_BALANCE);

export const autoRecharge = createPromiseAction(AUTO_RECHARGE);
